export enum ConfiguracoesSistema {
  /**
   * Ids dos tipos de movimentações que aceitam o parâmetro de processos.
   */
  TiposComProcesso = 1,
  /**
   * JSON `string[]` em `valor` — e-mails em cópia ao criar processo seletivo.
   * Nome lógico: `processo_seletivo_email_adicionais` (const CONFIGURACAO_PROCESSO_SELETIVO_EMAIL_ADICIONAIS).
   */
  ProcessoSeletivoEmailAdicionais = 2,
  /**
   * `valor`: `"true"` ou `"false"` — habilita o módulo “Relatórios de Atividades” no menu e rotas associadas.
   */
  ModuloRelatoriosAtividadesHabilitado = 3,
  /**
   * `valor`: JSON com flags booleanas dos crons agendados na API (`BackgroundJobService`).
   */
  BackgroundJobsFlags = 4,
  /**
   * `valor`: número de meses para retenção de dados de candidatos reprovados (LGPD). Padrão `"24"`.
   */
  CandidatoLgpdRetencaoMeses = 5,
}

/** Chave lógica da configuração (armazenada com {@link ConfiguracoesSistema.ProcessoSeletivoEmailAdicionais}) */
export const CONFIGURACAO_PROCESSO_SELETIVO_EMAIL_ADICIONAIS = 'processo_seletivo_email_adicionais' as const;

/** Chave lógica da configuração (armazenada com {@link ConfiguracoesSistema.ModuloRelatoriosAtividadesHabilitado}) */
export const CONFIGURACAO_MODULO_RELATORIOS_ATIVIDADES_HABILITADO =
  'modulo_relatorios_atividades_habilitado' as const;

/** Chave lógica da configuração (armazenada com {@link ConfiguracoesSistema.BackgroundJobsFlags}) */
export const CONFIGURACAO_BACKGROUND_JOBS_FLAGS = 'background_jobs_flags' as const;

/** Chave lógica da configuração (armazenada com {@link ConfiguracoesSistema.CandidatoLgpdRetencaoMeses}) */
export const CONFIGURACAO_CANDIDATO_LGPD_RETENCAO_MESES = 'candidato_lgpd_retencao_meses' as const;
